// File: packages/apps/workoutsmart/src/sync/exerciseDefinitionSyncDriver.js
import { fetchResource } from '@platform/core/src/services/resourceApi';
import { applyPatchWithPartialProtection, mergeUpdateWithPartialProtection } from './syncUtils';

const transformExerciseDefinition = (resource) => {
  if (!resource) return null;
  return {
    ...resource,
    type: 'exercise_definition',
  };
};

const exerciseDefinitionSyncDriver = {
  async handleCreated(currentMap, content) {
    try {
      const newResource = await fetchResource(content.resource_type, content.resource_id);
      if (!newResource) return currentMap;
      const transformedResource = transformExerciseDefinition(newResource);
      return { ...currentMap, [content.resource_id]: transformedResource };
    } catch (error) {
      return currentMap;
    }
  },

  handleUpdated(currentMap, content) {
    if (!content.value) return currentMap;
    const existingResource = currentMap[content.resource_id];
    
    const protectedValue = mergeUpdateWithPartialProtection(existingResource, content.value);
    const transformedValue = transformExerciseDefinition(protectedValue);
    
    return { ...currentMap, [content.resource_id]: transformedValue };
  },

  handlePatched(currentMap, content) {
    const resourceToPatch = currentMap[content.resource_id];
    if (!resourceToPatch) return currentMap;

    try {
      const patchedResource = applyPatchWithPartialProtection(resourceToPatch, content.patches);
      const transformedResource = transformExerciseDefinition(patchedResource);
      return { ...currentMap, [content.resource_id]: transformedResource };
    } catch (e) {
      return currentMap;
    }
  },
};

export default exerciseDefinitionSyncDriver;